export default __webpack_public_path__ + "3c445f8398b7b5fb262add5e8366b616.svg";